import { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  Box,
  Popover,
  Paper,
  InputAdornment,
} from "@mui/material";
import { SketchPicker } from "react-color";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api";

import SwitchButton from "../../../components/SwitchButton/SwitchButton";
const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  item,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    name: {
      en: "",
      ar: "",
    },
    color: "#E63050",
    active: 1,
    type: "color",
  });
  const [loading, setLoading] = useState(false);
  const [colorPickerAnchor, setColorPickerAnchor] = useState(null);
  const isColorPickerOpen = Boolean(colorPickerAnchor);

  console.log(currentView);
  // Reset form values when modal opens or item changes
  useEffect(() => {
    if (item) {
      // If editing an existing item
      setFormData({
        name: {
          en: item?.name_en || "",
          ar: item?.name_ar || "",
        },
        color: item.color || "#E63050",
        active: item.active,
        type: item.type || "color",
      });
    } else {
      // If creating a new item
      let type = "color";
      if (currentView.includes("Size")) {
        type = "size";
      } else if (currentView.includes("Unit")) {
        type = "unit";
      }

      setFormData({
        name: {
          en: "",
          ar: "",
        },
        color: "#E63050",
        active: true,
        type: type,
      });
    }
  }, [item, currentView, open]);

  const handleColorClick = (event) => {
    setColorPickerAnchor(event.currentTarget);
  };

  const handleColorPickerClose = () => {
    setColorPickerAnchor(null);
  };

  const handleColorChange = (color) => {
    setFormData({
      ...formData,
      color: color.hex,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = item ? `/variations/${item.id}` : "/variations";
      const method = item ? "put" : "post";

      // Check if we're in edit mode (item exists)
      if (item) {
        // For edit operations, use x-www-form-urlencoded
        const urlEncodedData = new URLSearchParams();

        // Append all needed fields
        urlEncodedData.append("name[en]", formData.name.en);
        urlEncodedData.append("name[ar]", formData.name.ar);
        urlEncodedData.append("active", formData.active ? "1" : "0");
        urlEncodedData.append("type", formData.type);

        // Add color field only for color variation type
        if (formData.type === "color") {
          urlEncodedData.append("color", formData.color);
        }

        // Create custom config for Axios to use x-www-form-urlencoded
        const config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            // Authorization header will be added by the interceptor
          },
        };

        // Make API call with URLSearchParams and custom config
        await api[method](endpoint, urlEncodedData, config);
      } else {
        // For create operations, use multipart/form-data
        const formDataObj = new FormData();

        // Append all needed fields
        formDataObj.append("name[en]", formData.name.en);
        formDataObj.append("name[ar]", formData.name.ar);
        formDataObj.append("active", formData.active ? "1" : "0");
        formDataObj.append("type", formData.type);

        // Add color field only for color variation type
        if (formData.type === "color") {
          formDataObj.append("color", formData.color);
        }

        // Create custom config for Axios to override the default JSON content type
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization header will be added by the interceptor
          },
        };

        // Make API call with FormData and custom config
        await api[method](endpoint, formDataObj, config);
      }

      // Call onSuccess callback to trigger data refresh in parent
      if (onSuccess) {
        onSuccess();
      }

      // Close modal and refresh data
      onClose();
    } catch (error) {
      // Error handling could be added here
    } finally {
      setLoading(false);
    }
  };

  const renderColorForm = (isEdit = false) => (
    <div className="user-modal">
      <p className="user-modal-p">
        {isEdit ? "تعديل اللون" : "اضافة لون جديد"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="color-value" sx={{ backgroundColor: "white" }}>
            اللون
          </InputLabel>
          <OutlinedInput
            id="color-value"
            sx={{ borderRadius: "8px", cursor: "pointer" }}
            required
            value={formData.color}
            readOnly
            onClick={handleColorClick}
            endAdornment={
              <InputAdornment position="end">
                <Box
                  onClick={handleColorClick}
                  sx={{
                    width: 30,
                    height: 30,
                    backgroundColor: formData.color,
                    borderRadius: "4px",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                  }}
                />
              </InputAdornment>
            }
          />
        </FormControl>

        <Popover
          open={isColorPickerOpen}
          anchorEl={colorPickerAnchor}
          onClose={handleColorPickerClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Paper elevation={3} sx={{ p: 1 }}>
            <SketchPicker
              color={formData.color}
              onChangeComplete={handleColorChange}
              disableAlpha={true}
              width={250}
            />
          </Paper>
        </Popover>

        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-en" sx={{ backgroundColor: "white" }}>
            الاسم بالانجليزية
          </InputLabel>
          <OutlinedInput
            id="name-en"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-ar" sx={{ backgroundColor: "white" }}>
            الاسم بالعربية
          </InputLabel>
          <OutlinedInput
            id="name-ar"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <div
          className="state"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
          }}
        >
          <p
            style={{
              margin: "0",
              fontWeight: "bold",
              textAlign: "right",
            }}
          >
            الحالة
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                color: formData.active === 1 ? "#4caf50" : "#f44336",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              {formData.active === 1 ? "مفعل" : "غير مفعل"}
            </span>
            <SwitchButton
              checked={formData.active === 1}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  active: e.target.checked ? 1 : 0,
                })
              }
            />
          </div>
        </div>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BlueButton
            text={isEdit ? "حفظ التغييرات" : "اضافة"}
            size="medium"
            variant="fill"
            type="submit"
            disabled={loading}
            icon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          />
        </Box>
      </form>
    </div>
  );

  const renderSizeForm = (isEdit = false) => (
    <div className="user-modal">
      <p className="user-modal-p">
        {isEdit ? "تعديل الحجم" : "اضافة حجم جديد"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-en" sx={{ backgroundColor: "white" }}>
            الاسم بالانجليزية
          </InputLabel>
          <OutlinedInput
            id="name-en"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-ar" sx={{ backgroundColor: "white" }}>
            الاسم بالعربية
          </InputLabel>
          <OutlinedInput
            id="name-ar"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <div
          className="state"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
          }}
        >
          <span
            style={{
              color: formData.active === 1 ? "#4caf50" : "#f44336",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            {formData.active === 1 ? "مفعل" : "غير مفعل"}
          </span>
          <SwitchButton
            checked={formData.active === 1}
            onChange={(e) =>
              setFormData({
                ...formData,
                active: e.target.checked ? 1 : 0,
              })
            }
          />
        </div>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BlueButton
            text={isEdit ? "حفظ التغييرات" : "اضافة"}
            size="medium"
            variant="fill"
            type="submit"
            disabled={loading}
            icon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          />
        </Box>
      </form>
    </div>
  );

  const renderUnitForm = (isEdit = false) => (
    <div className="user-modal">
      <p className="user-modal-p">
        {isEdit ? "تعديل المقاس" : "اضافة مقاس جديد"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-en" sx={{ backgroundColor: "white" }}>
            الاسم بالانجليزية
          </InputLabel>
          <OutlinedInput
            id="name-en"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel htmlFor="name-ar" sx={{ backgroundColor: "white" }}>
            الاسم بالعربية
          </InputLabel>
          <OutlinedInput
            id="name-ar"
            sx={{ borderRadius: "8px" }}
            required
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <div
          className="state"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
          }}
        >
          <span
            style={{
              color: formData.active === 1 ? "#4caf50" : "#f44336",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            {formData.active === 1 ? "مفعل" : "غير مفعل"}
          </span>
          <SwitchButton
            checked={formData.active === 1}
            onChange={(e) =>
              setFormData({
                ...formData,
                active: e.target.checked ? 1 : 0,
              })
            }
          />
        </div>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BlueButton
            text={isEdit ? "حفظ التغييرات" : "اضافة"}
            size="medium"
            variant="fill"
            type="submit"
            disabled={loading}
            icon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          />
        </Box>
      </form>
    </div>
  );

  const views = {
    createColor: () => renderColorForm(false),
    editColor: () => renderColorForm(true),
    createSize: () => renderSizeForm(false),
    editSize: () => renderSizeForm(true),
    createUnit: () => renderUnitForm(false),
    editUnit: () => renderUnitForm(true),
  };

  return (
    <SwipeableDrawer
      anchor="left"
      sx={{ zIndex: "1202" }}
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableScrollLock
    >
      {(views[currentView] || (() => <div></div>))()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
